@import '../../utils/control-inactive.css';
@import '../../utils/control-density.css';
@import '../../utils/focus-ring.css';
@import '../../utils/interaction-fill.css';
@import '../../utils/forced-colors.css';

:host {
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  gap: var(--ds-control-gap);
  height: var(--ds-control-height);
  padding: 0 var(--ds-control-padding-inline);
  border-radius: var(--ds-control-radius);
  cursor: default;
  user-select: none;
}

:host(.checkbox--described) {
  height: auto;
  min-height: var(--ds-control-height);
  padding-block: var(--dimension-space-075);
}

:host(.checkbox--presentation) {
  width: var(--ds-control-icon);
  height: var(--ds-control-icon);
  padding: 0;
  gap: 0;
  pointer-events: none;
}

/* Inactive: `.ds-control-inactive` (50% opacity). */

:host(.checkbox--lg) {
  --_checkbox-box: var(--dimension-iconography-md);
  --_checkbox-stroke: var(--dimension-stroke-width-018);
}

:host(.checkbox--md) {
  --_checkbox-box: var(--dimension-iconography-sm);
  --_checkbox-stroke: var(--dimension-stroke-width-015);
}

:host(.checkbox--sm) {
  --_checkbox-box: var(--dimension-iconography-xs);
  --_checkbox-stroke: var(--dimension-stroke-width-012);
}

:host(.checkbox--xs) {
  --_checkbox-box: var(--dimension-size-100);
  --_checkbox-stroke: calc(var(--dimension-stroke-width-base) * 3 / 32);
}

.checkbox__placement {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: var(--ds-control-icon);
  height: var(--ds-control-icon);
}

.box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: var(--_checkbox-box);
  height: var(--_checkbox-box);
  border: 0;
  border-radius: var(--dimension-radius-025);
  box-shadow: inset 0 0 0 var(--_checkbox-stroke) var(--color-foreground-tertiary);
  transition:
    background-color var(--effect-motion-short-2),
    box-shadow var(--effect-motion-short-2);
}

.box--marked {
  color: var(--color-foreground-on-bold-background-primary);
  background-color: var(--color-background-bold-brand);
  box-shadow: none;
}

.checkbox__mark {
  width: 100%;
  height: 100%;
  flex-shrink: 0;
  fill: currentColor;
}

.checkbox__copy {
  display: grid;
  flex: 1;
  gap: var(--dimension-space-025);
  min-width: 0;
  padding: 0 var(--ds-control-label-inset);
}

@media (forced-colors: active) {
  .box {
    border: var(--_checkbox-stroke) solid var(--ds-forced-color-content);
    box-shadow: none;
  }

  .box--marked {
    color: var(--ds-forced-color-on-selected);
    background-color: var(--ds-forced-color-selected);
    border-color: var(--ds-forced-color-selected);
  }
}
